import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddMenuSlice = createSlice({
    name: "addMenu",
    initialState,
    reducers: {
        addMenuRequest(state) {
            state.loading = true;
        },
        addMenuRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addMenuRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addMenuStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addMenuRequest,
    addMenuRequestSuccess,
    addMenuRequestError,
    addMenuStateReset
} = AddMenuSlice.actions;

export default AddMenuSlice.reducer;
